/* eslint-disable react-hooks/exhaustive-deps */
import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import { Button, Divider, Grid } from "@mui/material";
import styles from "../../../../customer/styles/customerStyles.module.css";
import { useState } from "react";
import { useDispatch } from "react-redux";
import InputField from "../../../../../Authentication/components/InputField";
import {
  calculationForRefund,
  getAllOrders,
  refundOrderAmount,
} from "../../../../../api/order";
import placeholder from "../../../assets/image-placeholder.svg";
import { getAllDisputes } from "../../../../../api/order/disputes-admin";
import refundIcon from "../../../../../assets/img/refundbutton.jpeg";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "65%",
  height: "auto",
  textAlign: "center",
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  padding: "20px 50px",
  borderRadius: "10px",
};

export default function DeleteOrderModal({
  title,
  order,
  dispute_number,
  tabValue,
  type,
  disputeIssue,
}) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const dispatch = useDispatch();
  const [refundQuantity, setRefundQuantity] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefunded, setIsRefunded] = useState(false);

  const finalCost = (
    order?.pricing?.product_cost +
    (order?.shipping_method === "premium"
      ? (order?.pricing?.total_shipping_cost_non_electric_premium || 0) +
        order?.pricing?.total_shipping_cost
      : order?.pricing?.total_shipping_cost)
  ).toFixed(2);

  const [refundAmount, setRefundAmount] = useState(0);

  const [notes, setNotes] = useState("");

  const [changedItems, setChangedItems] = useState([]);

  const [itemsCalculation, setItemsCalculation] = useState(null);
  const totalAmount = itemsCalculation?.calculation?.total_amount || 0;
  const totalShippingCost =
    itemsCalculation?.calculation?.total_shipping_cost || 0;
  const totalProductCost =
    itemsCalculation?.calculation?.total_product_cost || 0;

  const dataFetchedRef = React.useRef(false);

  const manipulateLineItems = order?.line_items?.map((line_item) => {
    return {
      ...line_item,
      shipping_method: order?.shipping_method,
      shipping_country: order?.shipping_details?.shipping_country,
      orderId: order?._id,
      disputeIssue,
    };
  });

  React.useEffect(() => {
    if (open) {
      if (dataFetchedRef.current) return;
      dataFetchedRef.current = true;

      dispatch(calculationForRefund(manipulateLineItems)).then((res) => {
        setIsLoading(false);
        setItemsCalculation(res?.payload);
      });
    }
  }, [open]);

  React.useEffect(() => {
    if (open) {
      setIsLoading(true);
      dispatch(calculationForRefund(changedItems || manipulateLineItems)).then(
        (res) => {
          setIsLoading(false);
          setItemsCalculation(res?.payload);
        }
      );
    }
  }, [dispatch, changedItems, refundQuantity]);

  const packageShippingCost = (item) => {
    if (order?.pricing?.total_shipping_cost_non_electric_premium) {
      return Number(
        (
          item?.total_shipping_cost +
          (item?.total_shipping_cost_non_electric_premium >
          item?.total_shipping_cost
            ? item?.total_shipping_cost_non_electric_premium -
              item?.total_shipping_cost
            : 0)
        ).toFixed(2)
      );
    } else {
      return item?.total_shipping_cost;
    }
  };
  const packageCounts = {};
  let packageNumber = 1;

  const handleRefundAmount = () => {
    if (!isRefunded) {
      setIsRefunded(true);
      dispatch(
        refundOrderAmount({
          orderId: order?._id,
          disputeIssue: itemsCalculation?.calculation?.disputeIssue,
          lineItems: {
            dispute_number,
            total_shipping_cost: totalShippingCost,
            total_product_cost:
              totalProductCost || order?.pricing?.product_cost,
            total_amount:
              refundAmount ||
              (changedItems?.length > 0 && totalAmount) ||
              (changedItems?.length < 1 && finalCost) ||
              itemsCalculation?.calculation?.payable_amount_to_client,
            line_items:
              itemsCalculation?.calculation?.line_items || order?.line_items,
            notes,
            type: type || "",
            refund_amount_type:
              refundAmount !== 0 &&
              itemsCalculation?.calculation?.total_amount !== refundAmount
                ? "manual"
                : "full",
          },
        })
      ).then(() => {
        if (title) {
          dispatch(getAllDisputes({ page: 0, size: 50 }));
        } else {
          const value = tabValue === 2 ? "Processing" : "Shipped";
          dispatch(getAllOrders({ page: 0, status: value }));
        }

        handleClose();
      });
    }
  };

  console.log("changedItems", changedItems)
  return (
    <>
      <img
        src={refundIcon}
        alt="refund"
        style={{ width: "20px", height: "20px", cursor: "pointer" }}
        onClick={handleOpen}
      />
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
      >
        <Fade in={open}>
          <Box sx={style} className="">
            <>
              <h2
                className={styles.welcome_popup}
                style={{ marginBottom: "40px" }}
              >
                {title ? title : "Cancel and Refund Order"}
              </h2>

              <div>
                <div style={{ textAlign: "left" }}>
                  <div style={{ display: "flex" }}>
                    <h6>Total paid by client:</h6>
                    <h6 style={{ marginLeft: "10px", fontWeight: 600 }}>
                      €
                      {
                        itemsCalculation?.calculation
                          ?.total_amount_paid_by_client
                      }
                    </h6>
                  </div>
                  {itemsCalculation?.calculation?.packages?.length > 0 &&
                    itemsCalculation?.calculation?.packages?.map(
                      (item, index) => (
                        <div style={{ display: "flex" }}>
                          <h6 style={{ marginTop: 0 }}>
                            Shipping calculated (Package {index + 1}):
                          </h6>
                          <h6
                            style={{
                              marginLeft: "10px",
                              fontWeight: 600,
                              marginTop: 0,
                            }}
                          >
                            €{item?.total_product_cost?.toFixed(2)} + €
                            {order?.shipping_method === "premium"
                              ? packageShippingCost(item)
                              : item?.total_shipping_cost}{" "}
                            = €
                            {order?.shipping_method === "premium"
                              ? (
                                  item?.total_product_cost +
                                  packageShippingCost(item)
                                ).toFixed(2)
                              : (
                                  item?.total_product_cost +
                                  item?.total_shipping_cost
                                ).toFixed(2)}
                          </h6>
                        </div>
                      )
                    )}
                </div>
                <Grid container spacing={4} sx={{ textAlign: "left" }}>
                  <Grid
                    item
                    xs={8}

                    // display="flex"
                    // justifyContent="space-between"
                  >
                    <div
                      style={{
                        border: "1px solid #eee",
                        borderRadius: "5px",
                        padding: "15px",
                        height: "400px",
                        overflowY: "scroll",
                      }}
                      className="hide_scrollbar"
                    >
                      {order?.line_items?.map((line_item, index) => {
                        const productId = line_item.shopify_product_id;

                        if (!packageCounts[productId]) {
                          packageCounts[productId] = packageNumber;
                          packageNumber++;
                        }

                        return (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              // marginLeft:"10px",
                              marginBottom: "15px",
                              borderBottom: `${
                                index !== order?.line_items?.length - 1
                                  ? "1px solid #eee"
                                  : ""
                              } `,
                            }}
                            key={line_item?.variant_id}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "",
                                width: "60%",
                              }}
                            >
                              <img
                                src={line_item?.variant_image || placeholder}
                                style={{
                                  width: "40px",
                                  height: "40px",
                                  borderRadius: "8px",
                                }}
                                alt="variantimage"
                              />
                              <div
                                style={{ marginLeft: "20px", width: "auto" }}
                              >
                                <h6
                                  style={{
                                    marginTop: 0,
                                    marginBottom: 10,
                                    lineHeight: "1.5",
                                    color: "#1890FF",
                                  }}
                                >
                                  {line_item?.product_title}
                                </h6>
                                <div style={{ display: "flex" }}>
                                  <p
                                    style={{
                                      width: "auto",
                                      padding: "5px",
                                      background: "#eee",
                                      borderRadius: "8px",
                                      textAlign: "center",
                                      marginRight: "10px",
                                    }}
                                  >
                                    {line_item?.variant_title ||
                                      "Not available"}
                                  </p>
                                  {/* <p
                                    style={{
                                      border: "1px solid #eee",
                                      padding: "5px",
                                      borderRadius: "5px",
                                    }}
                                  >
                                    {" "}
                                    Package {packageCounts[productId]}
                                  </p> */}
                                </div>
                                <h6 style={{ marginTop: 20 }}>
                                  {/* {line_item?.sku || "Not available"} */}
                                  Product cost:{" "}
                                  <strong style={{ fontWeight: 600 }}>
                                    €{line_item?.original_price}
                                  </strong>
                                </h6>
                                <h6 style={{ marginTop: 0 }}>
                                  Shipping weight:{" "}
                                  <strong style={{ fontWeight: 600 }}>
                                    {line_item?.original_weight}gr
                                  </strong>
                                </h6>
                              </div>
                            </div>
                            <div
                              style={{
                                width: "100px",
                                position: "relative",
                                marginTop: "-5px",
                              }}
                            >
                              <InputField
                                type="number"
                                onChange={(e) => {
                                  setRefundQuantity(e.target.value);
                                  const value = Number(e.target.value);
                                  const findItem = changedItems?.find(
                                    (item) =>
                                      item?.shopify_variant_id ===
                                      line_item?.shopify_variant_id
                                  );
                                  const index = changedItems.indexOf(findItem);
                                  if (index > -1 && value === 0) {
                                    changedItems.splice(index, 1);

                                    const items =
                                      changedItems?.length > 0
                                        ? changedItems
                                        : [
                                            {
                                              orderId: order?._id,
                                              disputeIssue,
                                            },
                                          ];

                                    setChangedItems([...items]);
                                  }

                                  if (findItem && value !== 0) {
                                    changedItems[index] = {
                                      ...findItem,
                                      fulfillable_quantity: Number(
                                        value > line_item?.fulfillable_quantity
                                          ? line_item?.fulfillable_quantity
                                          : value
                                      ),
                                      disputeIssue,
                                    };

                                    setChangedItems([...changedItems]);
                                  }

                                  if (!findItem) {
                                    setChangedItems([
                                      ...changedItems,
                                      {
                                        ...line_item,
                                        orderId: order?._id,
                                        shipping_method: order?.shipping_method,
                                        shipping_country:
                                          order?.shipping_details
                                            ?.shipping_country,
                                        fulfillable_quantity: Number(
                                          value >
                                            line_item?.fulfillable_quantity
                                            ? line_item?.fulfillable_quantity
                                            : value
                                        ),
                                        disputeIssue,
                                      },
                                    ]);
                                  }
                                }}
                                defaultValue={0}
                                max={line_item?.fulfillable_quantity}
                              />
                              <div
                                style={{
                                  position: "absolute",
                                  right: "40px",
                                  top: "20px",
                                }}
                              >
                                <h6 style={{ marginTop: 12, fontSize: "13px" }}>
                                  / {line_item?.fulfillable_quantity}
                                </h6>
                              </div>
                            </div>
                            <h6>€{line_item?.original_price}</h6>
                          </div>
                        );
                      })}
                    </div>
                    <div
                      style={{
                        border: "1px solid #eee",
                        borderRadius: "5px",
                        padding: "10px 15px",
                        margin: "15px 0px",
                      }}
                    >
                      <h6
                        style={{
                          textAlign: "left",
                          marginBottom: 10,
                          fontWeight: 600,
                        }}
                      >
                        Reason for refund
                      </h6>
                      <InputField
                        placeholder="Reason for refund"
                        type="text"
                        size="small"
                        defaultValue={notes}
                        onChange={(e) => setNotes(e.target.value)}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={4}>
                    <div
                      style={{
                        height: "auto",
                        border: "1px solid #eee",
                        borderRadius: "5px",
                        padding: "10px",
                      }}
                    >
                      <h5 style={{ fontSize: "14px", marginBottom: "5px" }}>
                        Refund Summary
                      </h5>
                      {itemsCalculation?.calculation &&
                      changedItems?.length > 0 &&
                      !isLoading ? (
                        <div>
                          <div className="flexbox">
                            <div>
                              <h6 style={{ marginBottom: 0 }}>
                                Item product cost
                              </h6>
                              <h6>
                                {itemsCalculation?.calculation?.total_items}{" "}
                                items
                              </h6>
                            </div>
                            <h6 style={{ marginTop: 0 }}>€{totalAmount}</h6>
                          </div>
                          {/* <div className="flexbox">
                            <h6>Tax (included)</h6>
                            <h6>€0.00</h6>
                          </div> */}
                          <Divider />
                          <div className="flexbox">
                            <h6 style={{ fontWeight: 600 }}>Refund total</h6>
                            <h6 style={{ fontWeight: 600 }}>€{totalAmount}</h6>
                          </div>
                        </div>
                      ) : isLoading ? (
                        <h6>Updating...</h6>
                      ) : (
                        <h6>No items selected</h6>
                      )}

                      <Divider />
                      {/* <div>
                        <h5
                          style={{
                            textAlign: "left",
                            fontSize: "14px",
                            marginBottom: 10,
                            marginTop: "10px",
                          }}
                        >
                          Refund amount
                        </h5>
                        <h6 style={{ textAlign: "left", marginBottom: 10 }}>
                          Manual
                        </h6>
                        <InputField
                          key={refundQuantity === 0 ? 0 : totalAmount}
                          placeholder="€"
                          // disabled={
                          //   refundQuantity === 0 ||
                          //   itemsCalculation?.calculation?.total_amount === 0
                          // }
                          disabled
                          type="number"
                          size="small"
                          defaultValue={totalAmount || 0}
                          // max={totalAmount || finalCost}
                          onChange={(e) => {
                            if (Number(e.target.value) > totalAmount) {
                              setRefundAmount(Number(totalAmount));
                            }
                            setRefundAmount(Number(e.target.value));
                          }}
                        />
                        {refundAmount > totalAmount ? (
                          <h6 style={{ color: "tomato", marginTop: 5 }}>
                            Can’t refund more than available
                          </h6>
                        ) : (
                          <h6 style={{ textAlign: "left", marginTop: 5 }}>
                            €{itemsCalculation?.calculation?.total_amount} available for refund
                          </h6>
                        )}
                        <Divider />
                      </div> */}
                      {isLoading ? (
                        <Button variant="purple" disabled>
                          Updating...
                        </Button>
                      ) : (
                        <Button
                          variant="purple"
                          disabled={
                            refundAmount > totalAmount ||
                            refundQuantity === "0" ||
                            refundQuantity === 0 ||
                            isRefunded
                          }
                          // disabled={1 + 1 === 2}
                          sx={{
                            borderRadius: "5px",
                            marginBottom: "10px",
                          }}
                          onClick={() => {
                            handleRefundAmount();
                          }}
                        >
                          Refund €
                          {refundAmount ||
                            (changedItems?.length > 0 && totalAmount) ||
                            (changedItems?.length < 1 && totalAmount) ||
                            itemsCalculation?.calculation
                              ?.payable_amount_to_client ||
                            0}
                        </Button>
                      )}
                    </div>
                    <div
                      style={{
                        border: "1px solid #eee",
                        padding: "5px",
                        marginTop: "10px",
                      }}
                    >
                      <h6>
                        Remaining payments for{" "}
                        <strong style={{ fontWeight: 600 }}>
                          {itemsCalculation?.calculation
                            ?.total_non_refund_items || 0}
                        </strong>{" "}
                        items
                      </h6>
                      <h6>
                        Product costs:{" "}
                        <strong style={{ fontWeight: 600 }}>
                          €
                          {itemsCalculation?.calculation
                            ?.totalNonRefundItemsProductCost !== 1
                            ? itemsCalculation?.calculation
                                ?.totalNonRefundItemsProductCost
                            : 0}
                        </strong>
                      </h6>
                      <h6>
                        Shipping costs: €{" "}
                        <strong style={{ fontWeight: 600 }}>
                          {(
                            itemsCalculation?.calculation
                              ?.totalNonRefundItemsShippingCost || 0
                          ).toFixed(2)}
                        </strong>
                      </h6>
                      <h6>
                        Discount: €{" "}
                        <strong style={{ fontWeight: 600 }}>
                          {itemsCalculation?.calculation
                            ?.totalNonRefundItemsDiscount || 0}
                        </strong>
                      </h6>
                      <h6>
                        Total amount: €{" "}
                        <strong style={{ fontWeight: 600 }}>
                          {itemsCalculation?.calculation
                            ?.totalNonRefundItemsAmount !== 1
                            ? itemsCalculation?.calculation
                                ?.totalNonRefundItemsAmount
                            : 0}
                        </strong>
                      </h6>
                    </div>
                  </Grid>
                </Grid>
              </div>

              {/* <Grid
                container
                spacing={4}
                style={
                  deleteOrderType === "cancel-order"
                    ? { opacity: 0.5, pointerEvents: "none" }
                    : {}
                }
              >
                <Grid item md={4}>
                  <h6 style={{ textAlign: "left", marginBottom: 10 }}>
                    Amount to refund
                  </h6>
                  <InputField
                    placeholder="€"
                    type="number"
                    size="small"
                    defaultValue={refundAmount}
                    onChange={(e) => setRefundAmount(Number(e.target.value))}
                  />
                </Grid>
                <Grid item md={8}></Grid>
              </Grid> */}
              {/* <Button
                variant="purple"
                disabled={
                  deleteOrderType === "refund-order" &&
                  (notes === "" || refundAmount === "€" || refundAmount === 0)
                }
                sx={{
                  width: "auto",
                  borderRadius: "5px",
                }}
                onClick={() => {
                  dispatch(deleteOrder(cancelOrderPayload)).then(() => {
                    const value = tabValue === 2 ? "Processing" : "Shipped";
                    dispatch(getAllOrders({ page: 0, status: value }));
                  });
                  handleClose();
                }}
              >
                Confirm
              </Button> */}
            </>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}